import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    error: require('../assets/common_images/default_logo.png'),
    loading: require('../assets/common_images/default_logo.png'),
    attempt: 2
})